import React from 'react'
import { Route } from 'react-router-dom'
import { REDIRECT_TO_ROUTE } from 'core/routing/constants'
import RedirectToRoute from '.'

const router = (
  <Route exact path={REDIRECT_TO_ROUTE} component={RedirectToRoute} />
)

export default router
